import React from 'react'
import { Wallet, PieChart, Layers, TrendingUp, LineChart, ShieldCheck, Sparkles } from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { PORTFOLIO_CAPS } from '../data'
import { PREVIEWS } from '@/components/landing/home/architecture/previews'
const ICONS = { Wallet, PieChart, Layers, TrendingUp, LineChart, ShieldCheck }
export default function Portfolio() {
  const Portfolio = PREVIEWS.portfolio
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-12">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Portfolio &amp; Risk</Eyebrow>
          <SectionHeading align="center"
            title={<>Risk you can see <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">is risk you can manage.</span></>}
            subtitle="Aggregated holdings, live P&amp;L, factor exposure and drawdown alarms in one pane — across every broker and every strategy."
          />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-10">
          <div className="lg:col-span-2 order-2 lg:order-1">
            <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-white/[0.03] to-white/[0.01] p-4 backdrop-blur-xl h-full">
              <div className="flex items-center gap-1.5 rounded-md bg-black/40 px-2.5 py-2 border border-white/5 mb-3">
                <div className="h-2 w-2 rounded-full bg-red-500/70" />
                <div className="h-2 w-2 rounded-full bg-amber-500/70" />
                <div className="h-2 w-2 rounded-full bg-emerald-500/70" />
                <div className="ml-3 flex-1 h-5 rounded-md bg-white/[0.04] flex items-center px-2 text-[10px] font-mono text-zinc-500">app.kalkiai.trade/portfolio</div>
              </div>
              {Portfolio && <Portfolio />}
            </div>
          </div>
          <div className="lg:col-span-3 order-1 lg:order-2">
            <FeatureGrid items={PORTFOLIO_CAPS} icons={ICONS} cols={2} />
          </div>
        </div>
      </Container>
    </section>
  )
}
